<template>
    <div class="blog-item mb-4">
        <a class="image" :href="itemSrc">
            <img v-if="item.image" :src="item.image.public_path + '?size=entry'" class="blog-image" :alt="item.image.alt"/>
        </a>

        <div class="body blog-item-body">
            <div class="d-flex flex-column">
                <h6 class="blog-item-taxonomy" v-if="item.taxonomies">{{item.taxonomies.map(taxonomy => taxonomy.title).join(', ')}}</h6>
                <h4 class="blog-item-h4"><a :href="itemSrc">{{ item.title }}</a></h4>
                <div class="ellipsis" v-html="item.blurb"></div>
            </div>

            <a class="btn btn-danger flex-nowrap d-flex align-items-center justify-content-end" :href="itemSrc">
                <span class="">{{btnText}}</span>
                <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon">
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object,
        locale: String
    },
    computed: {
        btnText() {
            return this.locale == 'es' ? 'Conocer más' : 'Learn more';
        },
        itemSrc() {
            return `/${this.locale}/blog/${this.item.slug}`;
        }
    }
}
</script>
<style lang="scss" scoped>
.blog-item-taxonomy{
    font-size: .8em;
    color: #F80048;
    font-weight: 600;
}
.ellipsis {
  flex: 1;
  overflow: hidden;
  height: 110px;
  max-height: 110px;
}
.blog-item{
    max-width: 290px;
    margin: auto;
}
.body {
    display: flex;
    flex-direction: column;
}
.blog-image{
    height: calc(12vw + 12vh);
    object-fit: cover;
}
.blog-item-body{
    background-color: white;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px;
}
.blog-item-h4{
    color: #091D5A;
    font-weight: 600;
    max-height: 40px;
    height: 40px;
    overflow: hidden;
}
</style>